import React from "react";
import { Controller } from "react-hook-form";
import "react-phone-number-input/style.css";
import ReactPhoneInput from "react-phone-number-input";

// Handles every naming variant for the worldwide countries in the DB.
// Falls back to AE when the name is unknown/missing.
const COUNTRY_NAME_TO_ISO = {
  pakistan: "PK",
  "united arab emirates": "AE",
  "saudi arabia": "SA",
};

const getISOFromCountryName = (countryname) => {
  if (!countryname || typeof countryname !== "string") return "AE";
  return COUNTRY_NAME_TO_ISO[countryname.trim().toLowerCase()] ?? "AE";
};

export default function Phone({
  name,
  defaultCountry,
  label,
  rules = {},
  control,
  setPhone,
}) {
  const getCountryCode = () => getISOFromCountryName(defaultCountry);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const shouldFloatLabel = field.value && field.value.length > 1;

        return (
          <div className="relative w-full">
            <div className={`relative ${error ? "text-red-500" : "text-gray-700"}`}>
              {label && (
                <label
                  className={`
                    absolute left-14 px-1 transition-all duration-200 bg-white
                    ${shouldFloatLabel ? "-top-2 left-1 text-xs text-gray-500" : "top-2.5 text-sm text-gray-400"}
                    ${error ? "text-red-500" : ""}
                    pointer-events-none
                  `}
                >
                  {label}
                </label>
              )}

              <ReactPhoneInput
                international
                defaultCountry={getCountryCode()}
                value={field.value}
                className={`
                  w-full h-10 pt-1 px-4 pb-1 rounded-md border
                  ${error ? "border-red-500" : "border-gray-300 hover:border-gray-500 focus:border-blue-500"}
                  bg-white text-gray-900
                  [&>input]:w-full [&>input]:h-full [&>input]:pt-1 [&>input]:pb-1
                  [&>input]:text-sm [&>input]:outline-none [&>input]:bg-transparent
                `}
                onChange={(value) => {
                  field.onChange(value);
                  setPhone?.(value);
                }}
              />
            </div>
            {error && (
              <p className="mt-1 ml-3 text-xs text-red-500">{error.message}</p>
            )}
          </div>
        );
      }}
    />
  );
}
